import React from "react";
import PropTypes from "prop-types";
import { useFormikContext } from "formik";

import { UIComponent } from "./UIComponent";
import { AppErrorFormik } from "../AppErrorFormik";

export const AppSelect = ({ name, label, data, space, ...otherProps }) => {
  const { handleBlur, handleChange, errors, touched, values } = useFormikContext();
  return (
    <>
      <UIComponent
        onBlur={handleBlur}
        onChange={handleChange}
        label={label}
        value={values.name}
        name={name}
        data={data}
        space={space}
        {...otherProps}
      />
      <AppErrorFormik error={errors[name]} visible={touched[name]} />
    </>
  );
};

AppSelect.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  data: PropTypes.array.isRequired,
  space: PropTypes.bool,
};
